import ReviewerSidebar from "../components/ReviewerSidebar";
import useNotifications from "../hooks/useNotifications";
import { useMemo, useState } from "react";

export default function ReviewerNotifications() {
  const [search, setSearch] = useState("");
  const { notifications, unread, markAllRead, markAsRead } = useNotifications();

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return notifications;
    return notifications.filter((n) => (n.title + " " + n.message).toLowerCase().includes(q));
  }, [notifications, search]);

  return (
    <div className="flex min-h-screen bg-gray-100">
      <ReviewerSidebar />
      <main className="flex-1 p-6 space-y-6">
        <div className="flex justify-between items-center bg-gradient-to-r from-green-700 to-green-500 text-white p-5 rounded-xl shadow-md">
          <h2 className="text-2xl font-bold">Reviewer Notifications</h2>
          <div className="flex items-center gap-3">
            <input
              type="text"
              placeholder="Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="px-3 py-2 rounded text-black border focus:ring-2 focus:ring-green-600 outline-none"
            />
            <button
              onClick={markAllRead}
              className="bg-white text-green-700 px-3 py-2 rounded shadow-sm text-sm"
            >
              Mark all read
            </button>
            <div className="text-sm">Unread: <strong>{unread}</strong></div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-xl shadow">
          {filtered.length === 0 ? (
            <p className="text-gray-500">No notifications</p>
          ) : (
            <ul className="space-y-3">
              {filtered.map((n) => (
                <li key={n.id} className={`p-4 rounded border ${n.is_read ? 'bg-gray-50' : 'bg-white'}`}>
                  <div className="flex justify-between items-start gap-4">
                    <div>
                      <h4 className="font-semibold text-gray-800">{n.title}</h4>
                      <p className="text-sm text-gray-600">{n.message}</p>
                      <div className="text-xs text-gray-400 mt-2">{new Date(n.createdAt).toLocaleString()}</div>
                    </div>
                    <div className="flex flex-col items-end gap-2">
                      {!n.is_read && (
                        <button
                          onClick={() => markAsRead(n.id)}
                          className="text-sm bg-green-700 text-white px-3 py-1 rounded"
                        >
                          Mark read
                        </button>
                      )}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </main>
    </div>
  );
}
